<template>
	<div id="retained" class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search ref="buttonSearch" placeholder="搜索域名" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<span class="mr-4">当前查看域名：<el-tag>{{check_url}} </el-tag></span>
					
					<span>快捷查看： </span>
					<el-button class="mr-2"  @click="faskSearch('all')" type="primary" size="mini"
					v-auth="'add'+auth_val">全部</el-button>
					<el-button class="mr-2"  @click="faskSearch('android')" type="primary" size="mini"
					v-auth="'add'+auth_val">安卓</el-button>
					<el-button class="mr-2"  @click="faskSearch('ios')" type="primary" size="mini"
					v-auth="'add'+auth_val">苹果</el-button>
					
					<el-button class="mr-2"  @click="faskSearch('pc')" type="primary" size="mini"
					v-auth="'add'+auth_val">PC</el-button>
					<el-button class="mr-2"  @click="faskSearch('h5')" type="primary" size="mini"
					v-auth="'add'+auth_val">H5</el-button>
					
					<el-button class="mr-2"  @click="faskSearch('majiaxxx')" type="primary" size="mini"
					v-auth="'add'+auth_val">马甲</el-button>
					
					<span>   当前在线：<span style="color: red;">{{onlineNum}}</span></span>
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加背景</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>-->

				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						
				

						<el-form-item label="查看域名" class="mb-0">
							<el-select v-model="from.url" filterable size="small" placeholder="查看域名">
								<el-option
								v-for="(item,index) in url_list" :key="index"
								 :label="item.url" :value="item.url"></el-option>
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="时间" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<!-- <el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				

				<!-- <el-table-column align="center" prop="name"  label="赛程类型">
					<template slot-scope="v">
						<span v-if="v.row.type_id==1">足球</span>
						<span v-if="v.row.type_id==2">篮球</span>
					</template>
				</el-table-column> -->
				<el-table-column fixed align="center" prop="date"  label="日期">
				</el-table-column>
				<el-table-column align="center" prop="total"  label="新增">
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="次日留存">
					<template slot-scope="v">
						<span>{{v.row.day_1}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="2日留存">
					<template slot-scope="v">
						<span>{{v.row.day_2}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="3日留存">
					<template slot-scope="v">
						<span>{{v.row.day_3}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="4日留存">
					<template slot-scope="v">
						<span>{{v.row.day_4}} %</span>
					</template>
				</el-table-column>
			
				<el-table-column align="center" prop="day_1"  label="5日留存">
					<template slot-scope="v">
						<span>{{v.row.day_5}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="6日留存">
					<template slot-scope="v">
						<span>{{v.row.day_6}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="7日留存">
					<template slot-scope="v">
						<span>{{v.row.day_7}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="15日留存">
					<template slot-scope="v">
						<span>{{v.row.day_15}} %</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="day_1"  label="30日留存">
					<template slot-scope="v">
						<span>{{v.row.day_30}} %</span>
					</template>
				</el-table-column>
				
				


			




				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog title="拒绝通过" :visible.sync="createModel" top="5vh">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">

			

				<el-form-item label="拒绝原因" prop="remark">
					<el-input v-model="form.remark" placeholder="拒绝原因"
					 type="textarea"
					  :rows="5"
					 clearable size="small" style="width: 90%;"></el-input>
				</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				type:"",
				createModel: false,
				check_url:'',
				onlineNum:0,
				editIndex: -1,
				//搜索数据
				from: {
					id: '',
					url: '',
					time: [],
				},
				model_title: 'Host',
				auth_val: 'Mtlog',
				preUrl: "data/retainedList", //列表地址
				tableData: [],
				form: {
					id: 0,
					remark: '',
					
				},
				prop: 'date',
				sort: 'descending',
				rules: {
					remark: [{
							required: true,
							message: "请输入拒绝原因",
							trigger: 'blur',
						},

					]
				},
				url_list: [],
				check_img_list: [],
				cz_money:0,
				tx_money:0,
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		
		created() {
			let data = this.$route.query
			if(data.url){
				
				this.searchEvent(data.url)
			}
			//this.commonList('rule');
		},
		methods: {
			faskSearch(url){
				this.searchEvent(url)
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 关闭模态框
					}
				})
			},
			
			is_ok(item) {
				this.$confirm('确定通过此条申请吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.api.post('/apply/addKyc', {
						id: item.id,
						type: 1,
						remark:''
					}, {
						token: true
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getList()
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},

			

			// 打开模态框
			openModel(e, type) {
				// 修改
				this.form = {
					id:  e.id,
					remark: '',
					type:2
				}
				this.editIndex = e.id
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				console.log(e);
				this.tableData = e.list
				this.check_url = e.check_url
				this.url_list = e.url_list
				this.onlineNum = e.online
				
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					id: '',
					u_id: '',
					username: '',
					type: -1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
		}
	}
</script>

<style>
</style>
